import { render, staticRenderFns } from "./set_price_silver_sp_regi.vue?vue&type=template&id=7adfc5a9&"
import script from "./set_price_silver_sp_regi.vue?vue&type=script&lang=js&"
export * from "./set_price_silver_sp_regi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports